<template>
  <section class="renting-yacht-sec">
    <div class="sec-round-colors">
      <span class="bg-orange round-small"></span>
      <span class="bg-orange round-small"></span>
      <span class="bg-orange round-small"></span>
      <span class="bg-dark-blue round-small"></span>
      <span class="bg-dark-blue round-big"></span>
      <span class="bg-orange round-big"></span>
    </div>
    <div class="sec-bg">
      <img src="@/assets/img/bg/ship-part-bg-01.png" alt="Bg" />
    </div>
    <div class="container">
      <div class="section-header-two">
        <h2>Benefits Of Renting Yacht</h2>
        <p>
          Renting a yacht offers numerous benefits for individuals and groups
          looking to experience luxury, relaxation, and adventure on the water.
        </p>
      </div>
      <div
        class="renting-yacht-benifits d-flex align-items-center justify-content-between"
      >
        <ul>
          <li>
            <span class="benifit-icon"
              ><img src="@/assets/img/icons/benifits-icon-05.svg" alt="icon"
            /></span>
            <div class="benifit-contents">
              <h5>Luxurious Experience</h5>
              <p>
                Yacht rental provides a unique and luxurious experience that
                allows you to explore stunning coastal destinations.
              </p>
            </div>
          </li>
          <li>
            <span class="benifit-icon"
              ><img src="@/assets/img/icons/benifits-icon-04.svg" alt="icon"
            /></span>
            <div class="benifit-contents">
              <h5>Customized Itineraries</h5>
              <p>
                Yacht charters offer flexibility and freedom to create
                customized itineraries based on your interests and preferences.
              </p>
            </div>
          </li>
          <li>
            <span class="benifit-icon"
              ><img src="@/assets/img/icons/benifits-icon-05.svg" alt="icon"
            /></span>
            <div class="benifit-contents">
              <h5>Gourmet Dining and Catering</h5>
              <p>
                Many yacht charters offer gourmet dining options and catering
                services, allowing you to indulge in delicious cuisine.
              </p>
            </div>
          </li>
        </ul>
        <div class="yatcht-center-img">
          <span
            ><img
              src="@/assets/img/bg/benifits-sec-bg-01.png"
              class="img-fluid"
              alt="Img"
          /></span>
          <span class="roung-img-bg"></span>
        </div>
        <ul>
          <li>
            <span class="benifit-icon"
              ><img src="@/assets/img/icons/benifits-icon-03.svg" alt="icon"
            /></span>
            <div class="benifit-contents">
              <h5>Privacy and Exclusivity</h5>
              <p>
                With a private yacht charter, you have the opportunity to escape
                the crowds and enjoy intimate moments with your loved ones.
              </p>
            </div>
          </li>
          <li>
            <span class="benifit-icon"
              ><img src="@/assets/img/icons/benifits-icon-02.svg" alt="icon"
            /></span>
            <div class="benifit-contents">
              <h5>Variety of Activities</h5>
              <p>
                Yacht rental provides a unique and Yachts offer a wide range of
                onboard activities and amenities to keep you entertained
                throughout your charter.
              </p>
            </div>
          </li>
          <li>
            <span class="benifit-icon"
              ><img src="@/assets/img/icons/benifits-icon-01.svg" alt="icon"
            /></span>
            <div class="benifit-contents">
              <h5>Relaxation and Wellness</h5>
              <p>
                Yacht charters offer the ultimate relaxation and wellness
                experience, allowing you to unwind and rejuvenate in tranquil
                surroundings.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
